<template>
    <div class="Pagination">
        <mu-flex justify-content="between" align-items="center" style="margin-top:0px;" class="custom-pagination">
            <mu-flex align-items="center">
                <span>{{$t('common.pagination.number')}}</span>
                <mu-select v-model="current.pageSize" solo color="primary" class="page_select"
                    @change="function() {current.page = 1;changePage();}">
                    <mu-option label="10" :value="10"></mu-option>
                    <mu-option label="20" :value="20"></mu-option>
                    <mu-option label="50" :value="50"></mu-option>
                    <mu-option label="100" :value="100"></mu-option>
                </mu-select>
                <span v-if="current.totalSize > 0">{{$t('common.pagination.display')}} {{(current.page - 1) * current.pageSize + 1}} {{$t('common.pagination.unit')}} ~ {{current.page * current.pageSize > current.totalSize?current.totalSize:current.page * current.pageSize}} {{$t('common.pagination.total')}} {{current.totalSize}} {{$t('common.pagination.totalUnits')}}</span>
            </mu-flex>
            <mu-flex align-items="center">
                <span>{{$t('common.pagination.theFirst')}}</span>
                <mu-select v-model="current.page" solo color="primary" class="page_select"
                  @change="function() {changePage();}">
                  <mu-option v-for="pageNum in getPageNumOptions()" :key="pageNum" :label="pageNum.toString()" :value="pageNum"></mu-option>
                </mu-select>
                <span>{{$t('common.pagination.page')}}</span>
                <span style="margin-left:8px;">{{$t('common.pagination.total')}} {{Math.ceil(current.totalSize/current.pageSize)}} {{$t('common.pagination.totalPages')}}</span>
                <mu-flex style="margin-left:8px;">
                  <mu-button flat small style="width:32px !important;min-width:32px;" :disabled="current.page <= 1"
                    @click="function() {current.page --;changePage();}"><mu-icon value="keyboard_arrow_left"></mu-icon></mu-button>
                  <mu-button flat small style="width:32px !important;min-width:32px;" 
                    :disabled="current.page == Math.ceil(current.totalSize/current.pageSize) || current.totalSize == 0"
                    @click="function() {current.page ++;changePage();}"><mu-icon value="keyboard_arrow_right"></mu-icon></mu-button>
                </mu-flex>
            </mu-flex>
        </mu-flex>
    </div>
</template>
<script>
export default {
    name: "Pagination",
    data() {
        return {}
    },
    props: {
        current: Object,
        changePage: Function
    },

    methods: {
        getPageNumOptions() {
            if(!this.current.totalSize) return [1]

            var arr = new Array();
            let totalPage = Math.ceil(this.current.totalSize / this.current.pageSize);
            for (let i=1; i<=totalPage; i++) {
                arr.push(i);
            }
            return arr;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pagination.vue